import { useCallback, useEffect, useState } from "react";

import styles from "@/styles/components/embla-button.module.scss";

export const usePrevNextButtons = (emblaApi, onButtonClick) => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
    if (onButtonClick) onButtonClick(emblaApi);
  }, [emblaApi, onButtonClick]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
    if (onButtonClick) onButtonClick(emblaApi);
  }, [emblaApi, onButtonClick]);

  const onSelect = useCallback((emblaApi) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect);
    emblaApi.on("select", onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};

export const PrevButton = (props) => {
  const { children, ...restProps } = props;

  return (
    <button
      className={styles.emblaButton}
      type="button"
      {...restProps}
      aria-label="Próximo"
    >
      <svg
        width="15"
        height="24"
        viewBox="0 0 15 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.6612 21.7764L10.9617 22.491L1.52895 13.258C0.823684 12.5677 0.823684 11.4323 1.52895 10.742L10.9617 1.50898C11.6551 0.830341 12.7777 0.830341 13.4711 1.50898C14.1763 2.19931 14.1763 3.33471 13.471 4.02504L5.32352 12L13.471 19.975M11.6612 21.7764L13.471 19.975M11.6612 21.7764L10.9617 22.491C11.6551 23.1697 12.7777 23.1697 13.471 22.491L12.7715 21.7764L13.471 22.491C14.1763 21.8007 14.1763 20.6653 13.471 19.975M11.6612 21.7764L13.471 19.975"
          fill="white"
          stroke="white"
          strokeWidth="2"
        />
      </svg>
    </button>
  );
};

export const NextButton = (props) => {
  const { children, ...restProps } = props;

  return (
    <button
      className={styles.emblaButton}
      type="button"
      {...restProps}
      aria-label="Anterior"
    >
      <svg
        width="15"
        height="24"
        viewBox="0 0 15 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.33877 2.22361L4.03827 1.50898L13.471 10.742C14.1763 11.4323 14.1763 12.5677 13.471 13.258L4.03827 22.491C3.34495 23.1697 2.22227 23.1697 1.52895 22.491C0.823681 21.8007 0.823684 20.6653 1.52895 19.975L9.67648 12L1.52895 4.02505M3.33877 2.22361L1.52895 4.02505M3.33877 2.22361L4.03827 1.50898C3.34494 0.830341 2.22227 0.830341 1.52895 1.50898L2.22845 2.22361L1.52895 1.50898C0.823683 2.19931 0.823683 3.33471 1.52895 4.02505M3.33877 2.22361L1.52895 4.02505"
          fill="white"
          stroke="white"
          strokeWidth="2"
        />
      </svg>
    </button>
  );
};
